"use client";

import { useUrlSearchParams } from "@trydig/ui/next";
import { useCallback, useMemo } from "react";

type keys = "mobileMenu" | "cart" | "search" | "geo" | "filters" | "notifyMe";

export const useModal = (key: keys) => {
	const searchParams = useUrlSearchParams();
	const isOpen = useMemo(() => searchParams.has("modal", key), [searchParams, key]);

	const open = useCallback(() => {
		if (!searchParams.has("modal", key)) {
			searchParams.set("modal", key);
		}
	}, [searchParams, key]);

	const close = useCallback(() => {
		if (searchParams.has("modal", key)) {
			searchParams.delete("modal", key);
		}
	}, [searchParams, key]);

	const setOpen = useCallback(
		(openState: boolean) => {
			if (openState) {
				open();
			} else {
				close();
			}
		},
		[open, close],
	);

	const toggle = useCallback(() => {
		if (isOpen) {
			close();
		} else {
			open();
		}
	}, [close, isOpen, open]);

	return {
		toggle,
		isOpen,
		open,
		close,
		setOpen,
	};
};
